// Reliable app version identifier attached to feedback technical context.
// Sourced from package.json version at build; overridable via REACT_APP_VERSION.
export const APP_VERSION = process.env.REACT_APP_VERSION || "0.1.0";
